(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-pro"] && !Shopify.designMode) return;
  try {
    

/*
=========================================================
BANNER PRO MARQUEE ENGINE
=========================================================

The user enters ONE copy of the text.

The script measures that copy and automatically creates
enough copies to fill the banner.

Speed is calculated using:

    duration = copy width / pixels per second

This keeps the physical scrolling speed consistent
regardless of the message length.
=========================================================
*/

(function () {

  function getBanners() {
    return document.querySelectorAll('[data-banner-pro]');
  }


  /*
  =======================================================
  PRESERVE TRAILING SPACES
  =======================================================
  */

  function preserveTrailingSpaces(element) {
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT
    );

    const textNodes = [];
    let node;

    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    for (let i = textNodes.length - 1; i >= 0; i--) {
      const textNode = textNodes[i];
      const text = textNode.textContent;

      if (!text || text.trim() === '') {
        continue;
      }

      const match = text.match(/(\s+)$/u);

      if (match && match[1]) {
        const trailingWhitespace = match[1];

        const preservedWhitespace = trailingWhitespace.replace(
          / /g,
          '\u00A0'
        );

        textNode.textContent =
          text.slice(0, -trailingWhitespace.length) +
          preservedWhitespace;
      }

      break;
    }
  }


  /*
  =======================================================
  SETUP ONE BANNER
  =======================================================
  */

  function setupBanner(section) {
    if (!section) {
      return;
    }

    const track = section.querySelector('.bp-track');
    const originalCopy = section.querySelector('.bp-copy');
    const marquee = section.querySelector('.bp-marquee');

    if (!track || !originalCopy || !marquee) {
      return;
    }

    const originalHTML = originalCopy.innerHTML;

    track.style.animation = 'none';
    track.innerHTML = '';


    function createCopy() {
      const copy = document.createElement('span');

      copy.className = 'bp-copy';
      copy.innerHTML = originalHTML;

      preserveTrailingSpaces(copy);

      return copy;
    }


    const firstCopy = createCopy();
    track.appendChild(firstCopy);


    /*
    -------------------------------------------------------
    Wait for layout and fonts.
    -------------------------------------------------------
    */

    requestAnimationFrame(function () {

      const copyWidth =
        firstCopy.getBoundingClientRect().width;

      const containerWidth =
        marquee.getBoundingClientRect().width;


      if (copyWidth <= 0 || containerWidth <= 0) {
        return;
      }


      /*
      =====================================================
      CREATE ENOUGH COPIES

      Add more than the visible width so there is always
      content entering the viewport before the previous
      copy completes.
      =====================================================
      */

      const requiredCopies =
        Math.ceil(containerWidth / copyWidth) + 3;

      for (let i = 1; i < requiredCopies; i++) {
        track.appendChild(createCopy());
      }


      /*
      =====================================================
      MOVEMENT DISTANCE
      =====================================================
      */

      track.style.setProperty(
        '--bp-move',
        copyWidth + 'px'
      );


      /*
      =====================================================
      READ SPEED
      =====================================================
      */

      const computedStyle =
        window.getComputedStyle(section);

      const pixelsPerSecond =
        parseFloat(
          computedStyle.getPropertyValue('--bp-speed-px')
        );


      const speed =
        Number.isFinite(pixelsPerSecond) &&
        pixelsPerSecond > 0
          ? pixelsPerSecond
          : 110;


      /*
      =====================================================
      CALCULATE DURATION
      =====================================================
      */

      const duration =
        copyWidth / speed;

      track.style.setProperty(
        '--bp-duration',
        Math.max(duration, 0.05) + 's'
      );


      /*
      =====================================================
      RESTART ANIMATION
      =====================================================
      */

      track.style.animation = 'none';

      track.offsetHeight;

      track.style.animation = '';

    });
  }


  /*
  =======================================================
  SETUP ALL BANNERS
  =======================================================
  */

  function setupAllBanners() {
    getBanners().forEach(function (banner) {
      setupBanner(banner);
    });
  }


  /*
  =======================================================
  WAIT FOR FONTS
  =======================================================
  */

  function setupAfterFonts() {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        setupAllBanners();
      });
    } else {
      setupAllBanners();
    }
  }


  /*
  =======================================================
  INITIAL LOAD
  =======================================================
  */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      setupAfterFonts
    );
  } else {
    setupAfterFonts();
  }


  /*
  =======================================================
  WINDOW LOAD
  =======================================================
  */

  window.addEventListener(
    'load',
    function () {
      setupAfterFonts();
    }
  );


  /*
  =======================================================
  RESIZE
  =======================================================
  */

  let resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(
        function () {
          setupAfterFonts();
        },
        150
      );
    },
    {
      passive: true
    }
  );


  /*
  =======================================================
  SHOPIFY THEME EDITOR
  =======================================================
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (
        event.detail &&
        event.detail.sectionId
      ) {
        const section =
          document.getElementById(
            'banner-pro-' +
            event.detail.sectionId
          );

        if (section) {
          setTimeout(
            setupAfterFonts,
            50
          );
        }
      }
    }
  );


  /*
  =======================================================
  SHOPIFY SECTION REORDER
  =======================================================
  */

  document.addEventListener(
    'shopify:section:reorder',
    function () {
      setTimeout(
        setupAfterFonts,
        50
      );
    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-25v2-spin-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const atlasUrls = ["https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-01.webp?v=1792070455","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-02.webp?v=1792070464","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-03.webp?v=1792070504","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-04.webp?v=1792070475","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-05.webp?v=1792070485","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-06.webp?v=1792070522","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-07.webp?v=1792070514","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-08.webp?v=1792070531","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-09.webp?v=1792070544","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-10.webp?v=1792070552","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-11.webp?v=1792070582","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-12.webp?v=1792070570","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-13.webp?v=1792070560","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-14.webp?v=1792070593","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-15.webp?v=1792070601","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-16.webp?v=1792070612","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-17.webp?v=1792070620","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-18.webp?v=1792070648","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-19.webp?v=1792070629","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-20.webp?v=1792070637","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-21.webp?v=1792070666","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-22.webp?v=1792070658","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-23.webp?v=1792070675","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-24.webp?v=1792070683","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-25.webp?v=1792070692","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-26.webp?v=1792070702","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-27.webp?v=1792070712","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-28.webp?v=1792070722","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-29.webp?v=1792070733","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-30.webp?v=1792070741","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-31.webp?v=1792070770","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-32.webp?v=1792070750","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-33.webp?v=1792070779","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-34.webp?v=1792070788","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-35.webp?v=1792070798","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-36.webp?v=1792070807","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-37.webp?v=1792070817","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-38.webp?v=1792070834","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-39.webp?v=1792070845","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma25v2-1200-spin-40.webp?v=1792070854"];
  const framesPerAtlas = 9;
  const atlasColumns = 3;
  const frameSize = 1200;

  const init = (scope) => (scope.querySelectorAll ? scope.querySelectorAll("[data-spin-viewer=\"luma25v2\"]") : []).forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const img=root.querySelector("[data-fallback]"), canvas=root.querySelector("[data-canvas]"), stage=root.querySelector("[data-stage]"), osd=root.querySelector("[data-osd]"), range=root.querySelector("[data-range]"), status=root.querySelector("[data-status]"), visual=root.querySelector("[data-visual]"), play=root.querySelector("[data-play]"), playLabel=root.querySelector("[data-play-label]"), steps=root.querySelectorAll("[data-step]"), zoomButtons=root.querySelectorAll("[data-zoom]"), ctx=canvas.getContext("2d",{alpha:true});
    let count=0,index=0,request=0,playing=false,direction=1,timer=null,drag=null,wheelRemainder=0,frameDelay=1000/30,zoom=1,panX=0,panY=0;
    const reducedMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    const atlasCache=new Map();

    const scheduleOsdGlitch=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight&&!stage.classList.contains("is-spin-fallback")){
            osd?.classList.remove("is-glitching");
            void osd?.offsetWidth;
            osd?.classList.add("is-glitching");
            window.setTimeout(()=>osd?.classList.remove("is-glitching"),760);
          }
        }
        if(root.isConnected)scheduleOsdGlitch();
      },12000+Math.random()*8000);
    };
    scheduleOsdGlitch();
    const scheduleBorderPulse=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight){
            stage.classList.remove("is-glow-pulsing");
            void stage.offsetWidth;
            stage.classList.add("is-glow-pulsing");
            window.setTimeout(()=>stage.classList.remove("is-glow-pulsing"),560);
          }
        }
        if(root.isConnected)scheduleBorderPulse();
      },12000+Math.random()*8000);
    };
    scheduleBorderPulse();

    const enable=(on)=>{range.disabled=!on;play.disabled=!on;steps.forEach((b)=>b.disabled=!on);zoomButtons.forEach((b)=>b.disabled=!on);};
    const applyView=()=>{
      visual.style.setProperty("--spin-zoom",String(zoom));
      visual.style.setProperty("--spin-pan-x",panX+"px");
      visual.style.setProperty("--spin-pan-y",panY+"px");
      stage.classList.toggle("is-zoomed",zoom>1.001);
    };
    const setZoom=(value)=>{
      zoom=Math.max(1,Math.min(2.5,value));
      if(zoom===1){panX=0;panY=0;}
      applyView();
    };
    applyView();

    const loadAtlas=(atlasIndex)=>{
      if(atlasIndex<0||atlasIndex>=atlasUrls.length)return Promise.reject(new Error("Frame atlas is out of range"));
      if(atlasCache.has(atlasIndex))return atlasCache.get(atlasIndex).promise;
      const image=new Image();
      image.crossOrigin="anonymous";
      image.decoding="async";
      const promise=new Promise((resolve,reject)=>{
        image.onload=()=>resolve(image);
        image.onerror=()=>reject(new Error("Frame atlas failed to load"));
        image.src=atlasUrls[atlasIndex];
      });
      atlasCache.set(atlasIndex,{image,promise});
      promise.catch(()=>atlasCache.delete(atlasIndex));
      return promise;
    };
    const trimAtlases=(current)=>{
      for(const [atlasIndex,item] of atlasCache){
        if(Math.abs(atlasIndex-current)>1){
          item.image.onload=null; item.image.onerror=null; item.image.src="";
          atlasCache.delete(atlasIndex);
        }
      }
    };
    const warmNeighbor=(frameIndex)=>{
      const atlasIndex=Math.floor(frameIndex/framesPerAtlas), localIndex=frameIndex%framesPerAtlas;
      if(localIndex<=Math.floor(framesPerAtlas/2)&&atlasIndex+1<atlasUrls.length)loadAtlas(atlasIndex+1).catch(()=>{});
      if(localIndex>=Math.ceil(framesPerAtlas/2)&&atlasIndex>0)loadAtlas(atlasIndex-1).catch(()=>{});
    };

    const stop=()=>{
      playing=false; if(timer)window.clearTimeout(timer); timer=null;
      playLabel.textContent="▶"; play.setAttribute("aria-label","Play product spin");
    };
    const fail=(message)=>{
      stop(); enable(false); canvas.hidden=true; img.hidden=false;
      if(img.dataset.fallbackSrc)img.src=img.dataset.fallbackSrc;
      visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      status.textContent=message||"The animated view is ready. Frame controls are unavailable.";
    };
    const paint=async(next)=>{
      if(!count)return false;
      const i=(next%count+count)%count, ticket=++request;
      index=i;
      try{
        const atlasIndex=Math.floor(i/framesPerAtlas);
        const atlas=await loadAtlas(atlasIndex);
        if(ticket!==request)return false;
        const localIndex=i%framesPerAtlas, sx=(localIndex%atlasColumns)*frameSize, sy=Math.floor(localIndex/atlasColumns)*frameSize;
        canvas.width=frameSize; canvas.height=frameSize;
        ctx.clearRect(0,0,frameSize,frameSize);
        ctx.drawImage(atlas,sx,sy,frameSize,frameSize,0,0,frameSize,frameSize);
        range.value=String(i);
        range.setAttribute("aria-valuetext","Rotation position "+Math.round((count>1?i/(count-1):0)*100)+" percent");
        status.textContent="Drag or swipe horizontally to rotate.";
        img.hidden=true; canvas.hidden=false;
        visual.classList.remove("is-fallback"); stage.classList.remove("is-spin-fallback");
        trimAtlases(atlasIndex); warmNeighbor(i);
        return true;
      }catch(e){
        if(ticket===request)fail("The animated view is ready. Frame controls are unavailable.");
        return false;
      }
    };

    const tick=async()=>{
      if(!playing)return;
      await paint(index+direction);
      if(playing)timer=window.setTimeout(tick,frameDelay);
    };
    const start=(dir=direction)=>{
      if(!count)return;
      direction=dir<0?-1:1; playing=true;
      playLabel.textContent="Ⅱ"; play.setAttribute("aria-label","Pause product spin");
      if(timer)window.clearTimeout(timer); timer=window.setTimeout(tick,frameDelay);
    };

    range.addEventListener("input",()=>{stop();paint(Number(range.value));});
    steps.forEach((b)=>b.addEventListener("click",()=>{stop();paint(index+Number(b.dataset.step));}));
    zoomButtons.forEach((b)=>b.addEventListener("click",()=>{
      if(b.dataset.zoom==="in")setZoom(zoom+0.25);
      else if(b.dataset.zoom==="out")setZoom(zoom-0.25);
      else setZoom(1);
    }));
    play.addEventListener("click",()=>playing?stop():start());
    const pointers=new Map();
    let pinch=null;
    const pointDistance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
    stage.addEventListener("pointerdown",(event)=>{
      if(!count||(event.pointerType!=="touch"&&event.button!==0))return;
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      try{stage.setPointerCapture(event.pointerId);}catch(e){}
      if(pointers.size===2){
        drag=null;
        const points=[...pointers.values()];
        pinch={distance:Math.max(1,pointDistance(points[0],points[1])),zoom};
        return;
      }
      if(pointers.size>1)return;
      drag={id:event.pointerId,startX:event.clientX,startY:event.clientY,lastX:event.clientX,lastY:event.clientY,residual:0,mode:zoom>1.001?"pan":null};
      if(event.pointerType!=="touch"||zoom>1.001)stop();
    });
    stage.addEventListener("pointermove",(event)=>{
      if(pointers.has(event.pointerId))pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pointers.size>=2&&pinch){
        const points=[...pointers.values()];
        setZoom(pinch.zoom*pointDistance(points[0],points[1])/pinch.distance);
        event.preventDefault();
        return;
      }
      if(!drag||event.pointerId!==drag.id)return;
      const totalX=event.clientX-drag.startX,totalY=event.clientY-drag.startY;
      if(!drag.mode&&Math.max(Math.abs(totalX),Math.abs(totalY))>8){
        drag.mode=zoom>1.001?"pan":Math.abs(totalX)>=Math.abs(totalY)?"scrub":"ignore";
        if(drag.mode==="scrub")stop();
      }
      if(drag.mode==="pan"){
        panX+=event.clientX-drag.lastX;
        panY+=event.clientY-drag.lastY;
        applyView();
        event.preventDefault();
      }else if(drag.mode==="scrub"){
        drag.residual+=event.clientX-drag.lastX;
        const frames=Math.trunc(drag.residual/5);
        if(frames){drag.residual-=frames*5;paint(index+(event.pointerType==="touch"?frames:-frames));}
        event.preventDefault();
      }
      drag.lastX=event.clientX;
      drag.lastY=event.clientY;
    });
    const endPointer=(event)=>{
      pointers.delete(event.pointerId);
      if(pinch)pinch=null;
      if(drag&&event.pointerId===drag.id)drag=null;
    };
    stage.addEventListener("pointerup",endPointer);
    stage.addEventListener("pointercancel",endPointer);
    stage.addEventListener("wheel",(event)=>{
      if(!count||Math.abs(event.deltaX)<=Math.abs(event.deltaY))return;
      event.preventDefault();stop();wheelRemainder+=event.deltaX;
      const frames=Math.trunc(wheelRemainder/18);
      if(frames){wheelRemainder-=frames*18;paint(index+frames);}
    },{passive:false});

    const load=async()=>{
      img.hidden=false; visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      try{
        const first=await loadAtlas(0);
        if(!root.isConnected)return;
        count=Math.min(360,atlasUrls.length*framesPerAtlas);
        if(!count)throw new Error("No frame atlases configured");
        range.max=String(count-1); enable(true);
        canvas.width=frameSize; canvas.height=frameSize;
        const ready=await paint(0);
        if(ready){warmNeighbor(0);start(1);}
      }catch(e){fail("The animated view is ready. Frame controls are unavailable.");}
    };
    if("IntersectionObserver" in window){const observer=new IntersectionObserver((entries)=>{if(entries.some((entry)=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:"1400px 0px"});observer.observe(root);}
    else load();
  });
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>init(document),{once:true}); else init(document);
  document.addEventListener("shopify:section:load",(event)=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-contact"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.luma-contact__chat-note').forEach(function (note) {
    var status = note.querySelector('p:first-child strong');
    var link = note.querySelector('a[href="#live-chat"]');
    var section = note.closest('.luma-contact-section') || note.closest('section');
    if (!status || !link || !section) return;
    var projectStatus = window.LumaChatStatus || 'loading';
    status.setAttribute('data-luma-chat-status', '');
    status.setAttribute('aria-live', 'polite');
    function update() {
      var value = projectStatus === 'online' || projectStatus === 'offline' ? projectStatus : 'loading';
      var label = value === 'online' ? note.dataset.onlineLabel : value === 'offline' ? note.dataset.offlineLabel : note.dataset.loadingLabel;
      if (status.dataset.status !== value) {
        status.dataset.status = value;
        status.textContent = label || value;
      }
    }
    document.addEventListener('luma:chat-status', function (event) {
      projectStatus = event.detail;
      update();
    });
    link.addEventListener('click', function (event) {
      update();
      if (projectStatus !== 'offline') return;
      var form = section.querySelector('form');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      var field = form.querySelector('input:not([type="hidden"]), textarea');
      form.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      if (field) field.focus({ preventScroll: true });
    });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-freestyle-spin-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const atlasUrls = ["https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-01.webp?v=1792070013","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-02.webp?v=1792070030","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-03.webp?v=1792070021","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-04.webp?v=1792070042","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-05.webp?v=1792070050","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-06.webp?v=1792070060","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-07.webp?v=1792070070","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-08.webp?v=1792070082","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-09.webp?v=1792070091","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-10.webp?v=1792070100","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-11.webp?v=1792070110","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-12.webp?v=1792070128","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-13.webp?v=1792070120","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-14.webp?v=1792070139","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-15.webp?v=1792070149","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-16.webp?v=1792070160","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-17.webp?v=1792070170","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-18.webp?v=1792070180","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-19.webp?v=1792070189","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-20.webp?v=1792070201","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-21.webp?v=1792070217","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-22.webp?v=1792070225","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-23.webp?v=1792070234","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-24.webp?v=1792070244","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-25.webp?v=1792070254","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-26.webp?v=1792070262","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-27.webp?v=1792070272","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-28.webp?v=1792070289","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-29.webp?v=1792070305","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-30.webp?v=1792070313","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-31.webp?v=1792070322","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-32.webp?v=1792070335","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-33.webp?v=1792070344","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-34.webp?v=1792070354","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-35.webp?v=1792070364","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-36.webp?v=1792070374","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-37.webp?v=1792070384","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-38.webp?v=1792070392","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-39.webp?v=1792070401","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5freestyle-1200-spin-40.webp?v=1792070411"];
  const framesPerAtlas = 9;
  const atlasColumns = 3;
  const frameSize = 1200;

  const init = (scope) => (scope.querySelectorAll ? scope.querySelectorAll("[data-spin-viewer=\"luma5freestyle\"]") : []).forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const img=root.querySelector("[data-fallback]"), canvas=root.querySelector("[data-canvas]"), stage=root.querySelector("[data-stage]"), osd=root.querySelector("[data-osd]"), range=root.querySelector("[data-range]"), status=root.querySelector("[data-status]"), visual=root.querySelector("[data-visual]"), play=root.querySelector("[data-play]"), playLabel=root.querySelector("[data-play-label]"), steps=root.querySelectorAll("[data-step]"), zoomButtons=root.querySelectorAll("[data-zoom]"), ctx=canvas.getContext("2d",{alpha:true});
    let count=0,index=0,request=0,playing=false,direction=1,timer=null,drag=null,wheelRemainder=0,frameDelay=1000/30,zoom=1,panX=0,panY=0;
    const reducedMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    const atlasCache=new Map();

    const scheduleOsdGlitch=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight&&!stage.classList.contains("is-spin-fallback")){
            osd?.classList.remove("is-glitching");
            void osd?.offsetWidth;
            osd?.classList.add("is-glitching");
            window.setTimeout(()=>osd?.classList.remove("is-glitching"),760);
          }
        }
        if(root.isConnected)scheduleOsdGlitch();
      },12000+Math.random()*8000);
    };
    scheduleOsdGlitch();
    const scheduleBorderPulse=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight){
            stage.classList.remove("is-glow-pulsing");
            void stage.offsetWidth;
            stage.classList.add("is-glow-pulsing");
            window.setTimeout(()=>stage.classList.remove("is-glow-pulsing"),560);
          }
        }
        if(root.isConnected)scheduleBorderPulse();
      },12000+Math.random()*8000);
    };
    scheduleBorderPulse();

    const enable=(on)=>{range.disabled=!on;play.disabled=!on;steps.forEach((b)=>b.disabled=!on);zoomButtons.forEach((b)=>b.disabled=!on);};
    const applyView=()=>{
      visual.style.setProperty("--spin-zoom",String(zoom));
      visual.style.setProperty("--spin-pan-x",panX+"px");
      visual.style.setProperty("--spin-pan-y",panY+"px");
      stage.classList.toggle("is-zoomed",zoom>1.001);
    };
    const setZoom=(value)=>{
      zoom=Math.max(1,Math.min(2.5,value));
      if(zoom===1){panX=0;panY=0;}
      applyView();
    };
    applyView();

    const loadAtlas=(atlasIndex)=>{
      if(atlasIndex<0||atlasIndex>=atlasUrls.length)return Promise.reject(new Error("Frame atlas is out of range"));
      if(atlasCache.has(atlasIndex))return atlasCache.get(atlasIndex).promise;
      const image=new Image();
      image.crossOrigin="anonymous";
      image.decoding="async";
      const promise=new Promise((resolve,reject)=>{
        image.onload=()=>resolve(image);
        image.onerror=()=>reject(new Error("Frame atlas failed to load"));
        image.src=atlasUrls[atlasIndex];
      });
      atlasCache.set(atlasIndex,{image,promise});
      promise.catch(()=>atlasCache.delete(atlasIndex));
      return promise;
    };
    const trimAtlases=(current)=>{
      for(const [atlasIndex,item] of atlasCache){
        if(Math.abs(atlasIndex-current)>1){
          item.image.onload=null; item.image.onerror=null; item.image.src="";
          atlasCache.delete(atlasIndex);
        }
      }
    };
    const warmNeighbor=(frameIndex)=>{
      const atlasIndex=Math.floor(frameIndex/framesPerAtlas), localIndex=frameIndex%framesPerAtlas;
      if(localIndex<=Math.floor(framesPerAtlas/2)&&atlasIndex+1<atlasUrls.length)loadAtlas(atlasIndex+1).catch(()=>{});
      if(localIndex>=Math.ceil(framesPerAtlas/2)&&atlasIndex>0)loadAtlas(atlasIndex-1).catch(()=>{});
    };

    const stop=()=>{
      playing=false; if(timer)window.clearTimeout(timer); timer=null;
      playLabel.textContent="▶"; play.setAttribute("aria-label","Play product spin");
    };
    const fail=(message)=>{
      stop(); enable(false); canvas.hidden=true; img.hidden=false;
      if(img.dataset.fallbackSrc)img.src=img.dataset.fallbackSrc;
      visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      status.textContent=message||"The animated view is ready. Frame controls are unavailable.";
    };
    const paint=async(next)=>{
      if(!count)return false;
      const i=(next%count+count)%count, ticket=++request;
      index=i;
      try{
        const atlasIndex=Math.floor(i/framesPerAtlas);
        const atlas=await loadAtlas(atlasIndex);
        if(ticket!==request)return false;
        const localIndex=i%framesPerAtlas, sx=(localIndex%atlasColumns)*frameSize, sy=Math.floor(localIndex/atlasColumns)*frameSize;
        canvas.width=frameSize; canvas.height=frameSize;
        ctx.clearRect(0,0,frameSize,frameSize);
        ctx.drawImage(atlas,sx,sy,frameSize,frameSize,0,0,frameSize,frameSize);
        range.value=String(i);
        range.setAttribute("aria-valuetext","Rotation position "+Math.round((count>1?i/(count-1):0)*100)+" percent");
        status.textContent="Drag or swipe horizontally to rotate.";
        img.hidden=true; canvas.hidden=false;
        visual.classList.remove("is-fallback"); stage.classList.remove("is-spin-fallback");
        trimAtlases(atlasIndex); warmNeighbor(i);
        return true;
      }catch(e){
        if(ticket===request)fail("The animated view is ready. Frame controls are unavailable.");
        return false;
      }
    };

    const tick=async()=>{
      if(!playing)return;
      await paint(index+direction);
      if(playing)timer=window.setTimeout(tick,frameDelay);
    };
    const start=(dir=direction)=>{
      if(!count)return;
      direction=dir<0?-1:1; playing=true;
      playLabel.textContent="Ⅱ"; play.setAttribute("aria-label","Pause product spin");
      if(timer)window.clearTimeout(timer); timer=window.setTimeout(tick,frameDelay);
    };

    range.addEventListener("input",()=>{stop();paint(Number(range.value));});
    steps.forEach((b)=>b.addEventListener("click",()=>{stop();paint(index+Number(b.dataset.step));}));
    zoomButtons.forEach((b)=>b.addEventListener("click",()=>{
      if(b.dataset.zoom==="in")setZoom(zoom+0.25);
      else if(b.dataset.zoom==="out")setZoom(zoom-0.25);
      else setZoom(1);
    }));
    play.addEventListener("click",()=>playing?stop():start());
    const pointers=new Map();
    let pinch=null;
    const pointDistance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
    stage.addEventListener("pointerdown",(event)=>{
      if(!count||(event.pointerType!=="touch"&&event.button!==0))return;
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      try{stage.setPointerCapture(event.pointerId);}catch(e){}
      if(pointers.size===2){
        drag=null;
        const points=[...pointers.values()];
        pinch={distance:Math.max(1,pointDistance(points[0],points[1])),zoom};
        return;
      }
      if(pointers.size>1)return;
      drag={id:event.pointerId,startX:event.clientX,startY:event.clientY,lastX:event.clientX,lastY:event.clientY,residual:0,mode:zoom>1.001?"pan":null};
      if(event.pointerType!=="touch"||zoom>1.001)stop();
    });
    stage.addEventListener("pointermove",(event)=>{
      if(pointers.has(event.pointerId))pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pointers.size>=2&&pinch){
        const points=[...pointers.values()];
        setZoom(pinch.zoom*pointDistance(points[0],points[1])/pinch.distance);
        event.preventDefault();
        return;
      }
      if(!drag||event.pointerId!==drag.id)return;
      const totalX=event.clientX-drag.startX,totalY=event.clientY-drag.startY;
      if(!drag.mode&&Math.max(Math.abs(totalX),Math.abs(totalY))>8){
        drag.mode=zoom>1.001?"pan":Math.abs(totalX)>=Math.abs(totalY)?"scrub":"ignore";
        if(drag.mode==="scrub")stop();
      }
      if(drag.mode==="pan"){
        panX+=event.clientX-drag.lastX;
        panY+=event.clientY-drag.lastY;
        applyView();
        event.preventDefault();
      }else if(drag.mode==="scrub"){
        drag.residual+=event.clientX-drag.lastX;
        const frames=Math.trunc(drag.residual/5);
        if(frames){drag.residual-=frames*5;paint(index+(event.pointerType==="touch"?frames:-frames));}
        event.preventDefault();
      }
      drag.lastX=event.clientX;
      drag.lastY=event.clientY;
    });
    const endPointer=(event)=>{
      pointers.delete(event.pointerId);
      if(pinch)pinch=null;
      if(drag&&event.pointerId===drag.id)drag=null;
    };
    stage.addEventListener("pointerup",endPointer);
    stage.addEventListener("pointercancel",endPointer);
    stage.addEventListener("wheel",(event)=>{
      if(!count||Math.abs(event.deltaX)<=Math.abs(event.deltaY))return;
      event.preventDefault();stop();wheelRemainder+=event.deltaX;
      const frames=Math.trunc(wheelRemainder/18);
      if(frames){wheelRemainder-=frames*18;paint(index+frames);}
    },{passive:false});

    const load=async()=>{
      img.hidden=false; visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      try{
        const first=await loadAtlas(0);
        if(!root.isConnected)return;
        count=Math.min(360,atlasUrls.length*framesPerAtlas);
        if(!count)throw new Error("No frame atlases configured");
        range.max=String(count-1); enable(true);
        canvas.width=frameSize; canvas.height=frameSize;
        const ready=await paint(0);
        if(ready){warmNeighbor(0);start(1);}
      }catch(e){fail("The animated view is ready. Frame controls are unavailable.");}
    };
    if("IntersectionObserver" in window){const observer=new IntersectionObserver((entries)=>{if(entries.some((entry)=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:"1400px 0px"});observer.observe(root);}
    else load();
  });
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>init(document),{once:true}); else init(document);
  document.addEventListener("shopify:section:load",(event)=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luma-product-spin-viewer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const atlasUrls = ["https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-01.webp?v=1792069007","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-02.webp?v=1792069311","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-03.webp?v=1792069322","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-04.webp?v=1792069333","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-05.webp?v=1792069342","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-06.webp?v=1792069353","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-07.webp?v=1792069391","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-08.webp?v=1792069364","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-09.webp?v=1792069374","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-10.webp?v=1792069383","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-11.webp?v=1792069399","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-12.webp?v=1792069407","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-13.webp?v=1792069427","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-14.webp?v=1792069416","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-15.webp?v=1792069437","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-16.webp?v=1792069446","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-17.webp?v=1792069465","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-18.webp?v=1792069456","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-19.webp?v=1792069472","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-20.webp?v=1792069482","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-21.webp?v=1792069492","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-22.webp?v=1792069503","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-23.webp?v=1792069512","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-24.webp?v=1792069784","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-25.webp?v=1792069792","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-26.webp?v=1792069822","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-27.webp?v=1792069802","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-28.webp?v=1792069811","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-29.webp?v=1792069831","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-30.webp?v=1792069838","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-31.webp?v=1792069846","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-32.webp?v=1792069855","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-33.webp?v=1792069865","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-34.webp?v=1792069878","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-35.webp?v=1792069886","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-36.webp?v=1792069912","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-37.webp?v=1792069895","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-38.webp?v=1792069903","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-39.webp?v=1792069933","https://cdn.shopify.com/s/files/1/0484/6682/1282/files/luma5pro-1200-spin-40.webp?v=1792069924"];
  const framesPerAtlas = 9;
  const atlasColumns = 3;
  const frameSize = 1200;

  const init = (scope) => (scope.querySelectorAll ? scope.querySelectorAll("[data-spin-viewer=\"luma5pro\"]") : []).forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const img=root.querySelector("[data-fallback]"), canvas=root.querySelector("[data-canvas]"), stage=root.querySelector("[data-stage]"), osd=root.querySelector("[data-osd]"), range=root.querySelector("[data-range]"), status=root.querySelector("[data-status]"), visual=root.querySelector("[data-visual]"), play=root.querySelector("[data-play]"), playLabel=root.querySelector("[data-play-label]"), steps=root.querySelectorAll("[data-step]"), zoomButtons=root.querySelectorAll("[data-zoom]"), ctx=canvas.getContext("2d",{alpha:true});
    let count=0,index=0,request=0,playing=false,direction=1,timer=null,drag=null,wheelRemainder=0,frameDelay=1000/30,zoom=1,panX=0,panY=0;
    const reducedMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
    const atlasCache=new Map();

    const scheduleOsdGlitch=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight&&!stage.classList.contains("is-spin-fallback")){
            osd?.classList.remove("is-glitching");
            void osd?.offsetWidth;
            osd?.classList.add("is-glitching");
            window.setTimeout(()=>osd?.classList.remove("is-glitching"),760);
          }
        }
        if(root.isConnected)scheduleOsdGlitch();
      },12000+Math.random()*8000);
    };
    scheduleOsdGlitch();
    const scheduleBorderPulse=()=>{
      window.setTimeout(()=>{
        if(!reducedMotion.matches&&!document.hidden&&root.isConnected){
          const bounds=stage.getBoundingClientRect();
          if(bounds.bottom>0&&bounds.top<window.innerHeight){
            stage.classList.remove("is-glow-pulsing");
            void stage.offsetWidth;
            stage.classList.add("is-glow-pulsing");
            window.setTimeout(()=>stage.classList.remove("is-glow-pulsing"),560);
          }
        }
        if(root.isConnected)scheduleBorderPulse();
      },12000+Math.random()*8000);
    };
    scheduleBorderPulse();

    const enable=(on)=>{range.disabled=!on;play.disabled=!on;steps.forEach((b)=>b.disabled=!on);zoomButtons.forEach((b)=>b.disabled=!on);};
    const applyView=()=>{
      visual.style.setProperty("--spin-zoom",String(zoom));
      visual.style.setProperty("--spin-pan-x",panX+"px");
      visual.style.setProperty("--spin-pan-y",panY+"px");
      stage.classList.toggle("is-zoomed",zoom>1.001);
    };
    const setZoom=(value)=>{
      zoom=Math.max(1,Math.min(2.5,value));
      if(zoom===1){panX=0;panY=0;}
      applyView();
    };
    applyView();

    const loadAtlas=(atlasIndex)=>{
      if(atlasIndex<0||atlasIndex>=atlasUrls.length)return Promise.reject(new Error("Frame atlas is out of range"));
      if(atlasCache.has(atlasIndex))return atlasCache.get(atlasIndex).promise;
      const image=new Image();
      image.crossOrigin="anonymous";
      image.decoding="async";
      const promise=new Promise((resolve,reject)=>{
        image.onload=()=>resolve(image);
        image.onerror=()=>reject(new Error("Frame atlas failed to load"));
        image.src=atlasUrls[atlasIndex];
      });
      atlasCache.set(atlasIndex,{image,promise});
      promise.catch(()=>atlasCache.delete(atlasIndex));
      return promise;
    };
    const trimAtlases=(current)=>{
      for(const [atlasIndex,item] of atlasCache){
        if(Math.abs(atlasIndex-current)>1){
          item.image.onload=null; item.image.onerror=null; item.image.src="";
          atlasCache.delete(atlasIndex);
        }
      }
    };
    const warmNeighbor=(frameIndex)=>{
      const atlasIndex=Math.floor(frameIndex/framesPerAtlas), localIndex=frameIndex%framesPerAtlas;
      if(localIndex<=Math.floor(framesPerAtlas/2)&&atlasIndex+1<atlasUrls.length)loadAtlas(atlasIndex+1).catch(()=>{});
      if(localIndex>=Math.ceil(framesPerAtlas/2)&&atlasIndex>0)loadAtlas(atlasIndex-1).catch(()=>{});
    };

    const stop=()=>{
      playing=false; if(timer)window.clearTimeout(timer); timer=null;
      playLabel.textContent="▶"; play.setAttribute("aria-label","Play product spin");
    };
    const fail=(message)=>{
      stop(); enable(false); canvas.hidden=true; img.hidden=false;
      if(img.dataset.fallbackSrc)img.src=img.dataset.fallbackSrc;
      visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      status.textContent=message||"The animated view is ready. Frame controls are unavailable.";
    };
    const paint=async(next)=>{
      if(!count)return false;
      const i=(next%count+count)%count, ticket=++request;
      index=i;
      try{
        const atlasIndex=Math.floor(i/framesPerAtlas);
        const atlas=await loadAtlas(atlasIndex);
        if(ticket!==request)return false;
        const localIndex=i%framesPerAtlas, sx=(localIndex%atlasColumns)*frameSize, sy=Math.floor(localIndex/atlasColumns)*frameSize;
        canvas.width=frameSize; canvas.height=frameSize;
        ctx.clearRect(0,0,frameSize,frameSize);
        ctx.drawImage(atlas,sx,sy,frameSize,frameSize,0,0,frameSize,frameSize);
        range.value=String(i);
        range.setAttribute("aria-valuetext","Rotation position "+Math.round((count>1?i/(count-1):0)*100)+" percent");
        status.textContent="Drag or swipe horizontally to rotate.";
        img.hidden=true; canvas.hidden=false;
        visual.classList.remove("is-fallback"); stage.classList.remove("is-spin-fallback");
        trimAtlases(atlasIndex); warmNeighbor(i);
        return true;
      }catch(e){
        if(ticket===request)fail("The animated view is ready. Frame controls are unavailable.");
        return false;
      }
    };

    const tick=async()=>{
      if(!playing)return;
      await paint(index+direction);
      if(playing)timer=window.setTimeout(tick,frameDelay);
    };
    const start=(dir=direction)=>{
      if(!count)return;
      direction=dir<0?-1:1; playing=true;
      playLabel.textContent="Ⅱ"; play.setAttribute("aria-label","Pause product spin");
      if(timer)window.clearTimeout(timer); timer=window.setTimeout(tick,frameDelay);
    };

    range.addEventListener("input",()=>{stop();paint(Number(range.value));});
    steps.forEach((b)=>b.addEventListener("click",()=>{stop();paint(index+Number(b.dataset.step));}));
    zoomButtons.forEach((b)=>b.addEventListener("click",()=>{
      if(b.dataset.zoom==="in")setZoom(zoom+0.25);
      else if(b.dataset.zoom==="out")setZoom(zoom-0.25);
      else setZoom(1);
    }));
    play.addEventListener("click",()=>playing?stop():start());
    const pointers=new Map();
    let pinch=null;
    const pointDistance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
    stage.addEventListener("pointerdown",(event)=>{
      if(!count||(event.pointerType!=="touch"&&event.button!==0))return;
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      try{stage.setPointerCapture(event.pointerId);}catch(e){}
      if(pointers.size===2){
        drag=null;
        const points=[...pointers.values()];
        pinch={distance:Math.max(1,pointDistance(points[0],points[1])),zoom};
        return;
      }
      if(pointers.size>1)return;
      drag={id:event.pointerId,startX:event.clientX,startY:event.clientY,lastX:event.clientX,lastY:event.clientY,residual:0,mode:zoom>1.001?"pan":null};
      if(event.pointerType!=="touch"||zoom>1.001)stop();
    });
    stage.addEventListener("pointermove",(event)=>{
      if(pointers.has(event.pointerId))pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pointers.size>=2&&pinch){
        const points=[...pointers.values()];
        setZoom(pinch.zoom*pointDistance(points[0],points[1])/pinch.distance);
        event.preventDefault();
        return;
      }
      if(!drag||event.pointerId!==drag.id)return;
      const totalX=event.clientX-drag.startX,totalY=event.clientY-drag.startY;
      if(!drag.mode&&Math.max(Math.abs(totalX),Math.abs(totalY))>8){
        drag.mode=zoom>1.001?"pan":Math.abs(totalX)>=Math.abs(totalY)?"scrub":"ignore";
        if(drag.mode==="scrub")stop();
      }
      if(drag.mode==="pan"){
        panX+=event.clientX-drag.lastX;
        panY+=event.clientY-drag.lastY;
        applyView();
        event.preventDefault();
      }else if(drag.mode==="scrub"){
        drag.residual+=event.clientX-drag.lastX;
        const frames=Math.trunc(drag.residual/5);
        if(frames){drag.residual-=frames*5;paint(index+(event.pointerType==="touch"?frames:-frames));}
        event.preventDefault();
      }
      drag.lastX=event.clientX;
      drag.lastY=event.clientY;
    });
    const endPointer=(event)=>{
      pointers.delete(event.pointerId);
      if(pinch)pinch=null;
      if(drag&&event.pointerId===drag.id)drag=null;
    };
    stage.addEventListener("pointerup",endPointer);
    stage.addEventListener("pointercancel",endPointer);
    stage.addEventListener("wheel",(event)=>{
      if(!count||Math.abs(event.deltaX)<=Math.abs(event.deltaY))return;
      event.preventDefault();stop();wheelRemainder+=event.deltaX;
      const frames=Math.trunc(wheelRemainder/18);
      if(frames){wheelRemainder-=frames*18;paint(index+frames);}
    },{passive:false});

    const load=async()=>{
      img.hidden=false; visual.classList.add("is-fallback"); stage.classList.add("is-spin-fallback");
      try{
        const first=await loadAtlas(0);
        if(!root.isConnected)return;
        count=Math.min(360,atlasUrls.length*framesPerAtlas);
        if(!count)throw new Error("No frame atlases configured");
        range.max=String(count-1); enable(true);
        canvas.width=frameSize; canvas.height=frameSize;
        const ready=await paint(0);
        if(ready){warmNeighbor(0);start(1);}
      }catch(e){fail("The animated view is ready. Frame controls are unavailable.");}
    };
    if("IntersectionObserver" in window){const observer=new IntersectionObserver((entries)=>{if(entries.some((entry)=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:"1400px 0px"});observer.observe(root);}
    else load();
  });
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",()=>init(document),{once:true}); else init(document);
  document.addEventListener("shopify:section:load",(event)=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-link-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const fadeEls = document.querySelectorAll(".text-link-section.fade-in");
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
      }
    });
  }, { threshold: 0.1 });

  fadeEls.forEach(el => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
